<template>
  <div v-if="org.user_ids">
        <div class="container text-left">
            <div class="info mt-5">
                <div>
                    <h2>Partner: {{ org.name }}</h2>
                </div>
                <div>
                    <div>{{ org.address1 }}</div>
                    <div>{{ org.address2 }}</div>
                    <div>{{ org.city }}, {{ org.state }} {{ org.zip }}</div>
                </div>
                <div>{{ org.telephone | telephoneNumber }}
                </div>
                <div>{{ org.website }}</div>
                <router-link :to="{ name: 'org edit', params: { orgId: org._id }}" v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()" class="btn btn-secondary mt-3">Edit</router-link>
                <b-button v-if="!userIsInOrg() && !userPendingJoin() && !isUserAdminOrEditor()" @click="joinRequest()" class="mt-3">Request to Join Organization</b-button>
                <b-alert v-else-if="userPendingJoin()" show variant="primary" class="mt-3 text-center">Join Request Pending Review</b-alert>
                <b-card class="mt-5" v-if="org.membership_requests && org.membership_requests.length > 0">
                    <h3>Membership Requests:</h3>
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()">Reject</th>
                                <th v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()">Accept</th>
                            </tr>
                        </thead>
                        <tbody v-if="org.membership_requests">
                            <tr v-for="request in org.membership_requests" :key="request._id">
                                <td>{{ request.users[0].first_name }} {{ request.users[0].last_name }}</td>
                                <td>{{ request.users[0].email }}</td>
                                <td>{{ request.users[0].telephone }}</td>
                                <td v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()"><b-button size="sm" @click="membershipSendAcceptRejectRequest(false, request._id)">Reject</b-button></td>
                                <td v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()"><b-button size="sm" @click="membershipSendAcceptRejectRequest(true, request._id)">Accept</b-button></td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
                <b-card class="mt-5">
                    <h3>Members:</h3>
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()">Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in org.users" :key="user._id">
                                <td>{{ user.first_name }} {{ user.last_name }}</td>
                                <td>{{ user.email }}</td>
                                <td v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()">
                                  <b-button size="sm" v-if="user.email != $store.state.auth.mUser.email" @click="removeUserFromOrg(user._id, org._id)">Remove</b-button>
                                  <b-button size="sm" v-else @click="removeUserFromOrg(user._id, org._id)">Leave</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
                <b-card class="mt-5">
                    <div class="row">
                      <div class="col-lg-9">
                      <h3 class="text-left">Events:</h3>
                      </div>
                      <div class="col-lg-3 text-right">
                      <router-link v-if="userIsInOrg()" :to="{ name: 'event create'}" class="event-link-btn">
                        <b-button class="">Create</b-button>
                      </router-link>
                      </div>
                    </div>
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Date Range</th>
                                <th v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()">Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="event in org.events" :key="event._id">
                                <td><router-link :to="{ name: 'event detail', params: { eventId: event._id } }" class="event-link-btn">{{ event.name }}</router-link> </td>
                                <td>{{ event.start_on | dateOnly }} - {{ event.end_on | dateOnly }}</td>
                                <td v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()"><router-link :to="{ name: 'event edit', params: { eventId: event._id } }" class="btn btn-secondary event-link-btn">Edit</router-link></td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
                <b-card class="mt-5" v-if="org.eventChangeRequests.length > 0">
                  <h3>Events Pending Approval:</h3>
                  <table class="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Date Range</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="event in org.eventChangeRequests" :key="event._id">
                          <td>{{ event.listing.name }} <b-badge v-if="!event.listing._id" variant="success">NEW</b-badge></td>
                          <td>{{ event.listing.start_on | dateOnly }} - {{ event.listing.end_on | dateOnly }}</td>
                          <td v-if="event.listing._id"><!-- if it has a listing id then it is an edit of an existing event -->
                            <router-link :to="{ name: 'event detail', params: { eventId: event.listing._id } }" class="btn btn-secondary event-link-btn">View</router-link>
                            </td>
                          <td v-else> <!-- this is a new event -->
                            <router-link :to="{ name: 'event detail', params: { eventId: event._id } }" class="btn btn-secondary event-link-btn">View</router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                </b-card>
                <b-card class="mt-5">
                  <div class="row">
                    <div class="col-lg-9">
                    <h3 class="text-left">Locations:</h3>
                    </div>
                    <div class="col-lg-3 text-right">
                      <router-link v-if="userIsInOrg()" :to="{ name: 'locations create'}" class="event-link-btn">
                        <b-button class="">Create</b-button>
                    </router-link>
                </div>
                    </div>
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Location Type</th>
                                <th v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()">Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="location in org.locations" :key="location._id">
                                <td><router-link :to="{ name: 'locations detail', params: { locationId: location._id } }" class="">{{ location.name }}</router-link></td>
                                <td>{{ location._type }}</td>
                                <td v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || userIsInOrg()"><router-link :to="{ name: 'locations edit', params: { locationId: location._id } }" class="btn btn-secondary event-link-btn">Edit</router-link></td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      org: {},
    };
  },
  props: {
    orgId: String,
  },
  async created() {
    await this.loadOrg();
  },
  methods: {
    isUserAdminOrEditor() {
      return this.$store.state.auth.user.role === 'admin' || this.$store.state.auth.user.role === 'editor';
    },
    userPendingJoin() {
      return this.org.membership_requests.filter(mr => mr.user_id === this.$store.state.auth.mUser._id).length > 0;
    },
    userIsInOrg() {
      return this.org.user_ids.find(u => u === this.$store.state.auth.mUser._id);
    },
    async loadOrg() {
      const response = await axios.get(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${this.orgId}`);
      this.org = response.data.organization;
    },
    async membershipSendAcceptRejectRequest(accept, requestId) {
      const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/requests/${requestId}/${accept}`;
      const response = await axios.patch(url);
      if (response.status === 200) {
        this.$bvToast.toast(`You have successfully ${accept ? 'accepted' : 'rejected'} this request.`,
          {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });
      } else {
        this.$bvToast.toast(JSON.parse(response.data).message,
          {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
      }
      await this.loadOrg();
    },
    async joinRequest() {
      await this.$store.dispatch('organizations/requestToJoinOrg', this.orgId);
      this.$bvToast.toast('You have requested to join this organzation.',
        {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      await this.loadOrg();
    },
    async adminJoin() {
      await this.$store.dispatch('organizations/adminJoinOrg', this.orgId);
    },
    getUserMembershipRequestForOrg(orgId) {
      return this.$store.state.auth.mUser.membership_requests.find(mr => mr.organization_id === orgId);
    },
    async removeUserFromOrg(userId, orgId) {
      const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/removeUserFromOrg/${userId}/${orgId}`;
      const response = await axios.get(url);
      if (response.status === 200) {
        this.$bvToast.toast('You have successfully removed this user from the organization.',
          {
            title: 'Success',
            autoHideDelay: 5000,
            appendToast: true,
          });
      } else {
        this.$bvToast.toast(JSON.parse(response.data).message,
          {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
      }

      await this.loadOrg();
    },
  },
};
</script>

<style scoped>
.card {
  border:none;
}

</style>
